import { namedStateMapProvider } from "./namedState";

export const busyState = namedStateMapProvider( 'busyState' );

/**
 * retrieves the busy state for one single actionType
 * @param {string} actionType 
 */
export const actionTypeBusyState = actionType => state => ( { busyState: state.busyState && state.busyState[actionType] } );